import * as yup from 'yup';

export const VacationEntitlementSchema = yup.object({
  year: yup.number().required(),
  days: yup.number().required(),
});

export interface IVacationEntitlement {
  year: number;
  days: number;
}
